import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './helpers';
import App from './components/App';
import registerServiceWorker from './registerServiceWorker';
import { clientConfig, managerConfig } from './config';
import Analytics from './analytics/Analytics';

const firebase = require('firebase/app');

const MANAGER_APP = 'Firebase Manager App';

// Initialize Firebase
const clientFirebaseConfig = {
  apiKey: clientConfig.FIREBASE_API_KEY,
  authDomain: clientConfig.FIREBASE_AUTH_DOMAIN,
  databaseURL: clientConfig.FIREBASE_DATABASE_URL,
  projectId: clientConfig.FIREBASE_PROJECT_ID,
  storageBucket: clientConfig.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: clientConfig.FIREBASE_MESSAGING_SENDER_ID,
};

firebase.initializeApp(clientFirebaseConfig);
Analytics.initialize(clientConfig);

const managerFirebaseConfig = {
  apiKey: managerConfig.FIREBASE_API_KEY,
  authDomain: managerConfig.FIREBASE_AUTH_DOMAIN,
  databaseURL: managerConfig.FIREBASE_DATABASE_URL,
  projectId: managerConfig.FIREBASE_PROJECT_ID,
  storageBucket: managerConfig.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: managerConfig.FIREBASE_MESSAGING_SENDER_ID,
};

export default firebase.initializeApp(managerFirebaseConfig, MANAGER_APP);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js